import { api } from "./base";

export const postBooking = async ({ locale, values }) => {
  api.defaults.headers = { locale };
  const res = await api.post("/trip-request", { ...values });
  return res;
};
